import React from 'react'

import { CssBaseline, createTheme, ThemeProvider } from '@mui/material'

import palette from '../utils/palette'

const Theme = ({ children }) => (
  <ThemeProvider
    theme={createTheme({
      palette,
      typography: {
        h1: {
          fontFamily: ['Open Sans', 'Roboto', 'sans-serif'].join(','),
          textTransform: 'uppercase',
          fontSize: '2rem',
          letterSpacing: '0.13em',
        },
        button: {
          fontWeight: 'bold',
          textTransform: 'initial',
        },
      },
    })}
  >
    <link
      href="https://fonts.googleapis.com/css?family=Open+Sans:600|Roboto:300&display=swap"
      rel="stylesheet"
    />
    <CssBaseline />
    {children}
  </ThemeProvider>
)

export default Theme
